<template>
  <v-dialog v-model="dialog" persistent max-width="700">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :large="large" :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">{{
          isAT ? "Iniciativa" : isGov ? "Fases" : "Solução"
        }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Nome"
              name="nome"
              type="text"
              required
              v-model="payload.nome"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-group-solution-by-city-combobox
              :filter="edit ? payload : municipioGrupoSolucao"
              :onlyEnable="true"
              v-if="(filter && !filter.municipioGrupoSolucao) || edit"
              :loadfirst="true"
            ></app-group-solution-by-city-combobox>

            <v-text-field
              v-model="filter.municipioGrupoSolucao.nome"
              v-if="filter && filter.municipioGrupoSolucao && !edit"
              :label="`${
                isAT
                  ? 'Grupo de Iniciativa'
                  : isGov
                  ? 'Grupo de Fases'
                  : 'Grupo de Solução'
              }`"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Descrição"
              required
              v-model="payload.descricao"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row
          v-if="
            isFullAdmin || (config.verCustoPreco && groupsConfig.verCustoPreco)
          "
        >
          <v-col>
            <v-currency-field
              label="Custo"
              :prefix="currency"
              filled
              v-model="payload.custo"
            />
          </v-col>
          <v-col>
            <v-currency-field
              label="Preço"
              :prefix="currency"
              filled
              v-model="payload.preco"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-consultant-combobox
              :filter="payload"
              :isMultiple="podeSelecionarMaisDeUmUsuarioSolucao"
              :returnObject="true"
              @change="changeUser"
            ></app-consultant-combobox>
          </v-col>
        </v-row>
        <!-- Contratos por usuário selecionado -->
        <template
          v-if="
            Array.isArray(payload.usuarioId)
              ? payload.usuarioId.length > 0
              : payload.usuarioId
          "
        >
          <v-row
            v-for="(usuario, index) in usuariosSelecionados"
            :key="usuario.usuarioId || usuario"
            v-if="
              isFullAdmin ||
              (config.exibeContrato && groupsConfig.exibeContrato)
            "
          >
            <v-col>
              <v-card flat class="mb-3 pa-3" outlined>
                <v-card-subtitle class="pa-0 pb-2">
                  <div class="d-flex align-center">
                    <span class="font-weight-bold">
                      {{ getUsuarioNome(usuario, index) }}
                    </span>
                  </div>
                </v-card-subtitle>

                <ComboboxContratoByUser
                  :key="`contrato-${index}`"
                  :filter="getContratosFilter(index)"
                  :user="
                    typeof usuario === 'object' ? usuario.usuarioId : usuario
                  "
                  @onChange="(contratos) => updateContratos(index, contratos)"
                ></ComboboxContratoByUser>
              </v-card>
            </v-col>
          </v-row>
        </template>

        <v-row
          v-if="
            isFullAdmin ||
            (config.exibeComunicacaoInterna &&
              groupsConfig.exibeComunicacaoInterna)
          "
        >
          <v-col>
            <v-text-field
              v-model="payload.comunicacaoInterna"
              :label="`Comunicação Interna (CI)`"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row
          v-if="
            isFullAdmin ||
            (config.verDataContratoSolucao &&
              groupsConfig.verDataContratoSolucao)
          "
        >
          <v-col>
            <v-text-field
              v-model="payload.inicioContrato"
              v-mascara="'##/##/####'"
              label="Início do Contrato"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="payload.fimContrato"
              v-mascara="'##/##/####'"
              label="Término do Contrato"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            v-if="
              isFullAdmin ||
              (config.verStatusSolucao && groupsConfig.verStatusSolucao)
            "
          >
            <status-solucao-combobox
              :filter="payload"
            ></status-solucao-combobox>
          </v-col>
          <v-col
            v-if="
              isFullAdmin ||
              (config.verPortifolioSolucao && groupsConfig.verPortifolioSolucao)
            "
          >
            <v-checkbox
              v-model="payload.portifolio"
              label="Portifólio"
              color="primary"
            >
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row
          v-if="
            isFullAdmin ||
            (config.exibirSecretaria && groupsConfig.exibirSecretaria)
          "
        >
          <v-col>
            <combobox-secretaria
              :filter="payload"
              :municipioId="payload.municipioId"
            ></combobox-secretaria>
          </v-col>
        </v-row>

        <v-row
          v-if="
            isFullAdmin ||
            (config.verTipoSolucao && groupsConfig.verTipoSolucao)
          "
        >
          <v-col>
            <combobox-tipo-solucao :filter="payload"></combobox-tipo-solucao>
          </v-col>
        </v-row>

        <template
          v-if="
            isFullAdmin ||
            (config.exibeDetalhesSolucao && groupsConfig.exibeDetalhesSolucao)
          "
        >
          <v-row>
            <v-col>
              <v-radio-group v-model="payload.monitoramento">
                <v-radio
                  v-for="monitoramento in tiposMonitoramento"
                  :label="monitoramento.label"
                  :value="monitoramento.value"
                  :key="monitoramento.value"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row v-if="payload.monitoramento === 1">
            <v-col>
              <v-text-field
                v-model="payload.maxHoras"
                label="Máximo de horas"
                placeholder="12"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </template>
        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              v-model="payload.dataInicioString"
              v-mask="'##/##/####'"
              label="Data de Início"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              v-model="payload.dataTerminoString"
              v-mask="'##/##/####'"
              label="Data de Término"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Número de visitas presenciais"
              name="numero-visitas-presenciais"
              type="number"
              required
              v-model="payload.visitasPresenciais"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Horas previstas de visitas presenciais"
              name="horas-previstas-visitas-presenciais"
              type="number"
              required
              v-model="payload.horasPrevistasVisitasPresenciais"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Número de trabalhos de escritório"
              name="numero-trabalhos-escritorio"
              type="number"
              required
              v-model="payload.trabalhosEscritorio"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Horas previstas de trabalhos de escritório"
              name="horas-previstas-trabalhos-escritorio"
              type="number"
              required
              v-model="payload.horasPrevistasTrabalhosEscritorio"
            ></v-text-field>
          </v-col>
        </v-row>
        <template
          v-if="
            isFullAdmin ||
            (config.exibeDetalhesSolucao && groupsConfig.exibeDetalhesSolucao)
          "
        >
          <v-row>
            <v-col>
              <v-checkbox
                v-model="payload.naoComputaHoras"
                label="Não Computa Horas?"
                color="primary"
              >
              </v-checkbox>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="close">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { citySolutionAPI } from "@/modules/city/API/CitySolutionAPI";
import AppGroupSolutionByCityCombobox from "@/modules/city/components/terms-reference/groups-solution/ComboboxByCity.vue";
import { AppConsultantCombobox } from "@/modules/user";
import { mapActions, mapGetters } from "vuex";
import { usuarioPermissaoMunicipioSolucaoApi } from "@/apis";
import ComboboxSecretaria from "../../../city/components/secretaria/ComboboxSecretaria.vue";
import ComboboxTipoSolucao from "@/modules/tipoSolucao/components/Combobox";
import StatusSolucaoCombobox from "@/components/combobox/solucoes/StatusSolucaoCombobox.vue";
import moment from "moment";
import ComboboxContratoByUser from "@/modules/contratos/components/ComboboxByUser.vue";

export default {
  name: "AppModalInsertSolution",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
    filter: { municipioGrupoSolucao: {} },
    municipioSolucao: {},
    allSolutions: [],
  },
  components: {
    AppGroupSolutionByCityCombobox,
    AppConsultantCombobox,
    ComboboxSecretaria,
    ComboboxTipoSolucao,
    StatusSolucaoCombobox,
    ComboboxContratoByUser,
  },
  computed: {
    ...mapGetters(["user", "isAT", "isFullAdmin", "isGov"]),
    podeSelecionarMaisDeUmUsuarioSolucao() {
      return (
        this.isFullAdmin ||
        (this.config.podeSelecionarMaisDeUmUsuarioSolucao &&
          this.groupsConfig.podeSelecionarMaisDeUmUsuarioSolucao)
      );
    },
    usuariosSelecionados() {
      if (!this.payload.usuarioId) return [];

      if (Array.isArray(this.payload.usuarioId)) {
        return this.payload.usuarioId.filter((user) => user && user !== 0);
      }

      return this.payload.usuarioId !== 0 ? [this.payload.usuarioId] : [];
    },
  },
  data() {
    return {
      payload: {
        monitoramento: 1,
        municipioId: this.$route.params.id,
        municipioGrupoSolucao: {},
        usuarioId: [],
        usuariosId: [],
        status: null,
        contratos: {},
      },

      municipioGrupoSolucao: {
        municipioGrupoSolucao: {},
      },
      currency: "R$",
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      dialog: false,
      loadfirst: false,
      tiposMonitoramento: [
        { label: "Tarefas", value: 1 },
        { label: "Visitas", value: 2 },
      ],
      contratosPorUsuario: {}, // Armazena contratos por índice de usuário
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    onContratoChange(contrato) {
      this.payload.contratos = contrato;
    },
    close() {
      if (this.edit !== true) {
        this.payload = {
          monitoramento: 1,
          municipioId: this.$route.params.id,
          municipioGrupoSolucao: this.municipioGrupoSolucao,
        };
      } else {
        this.payload = {
          ...this.object,
          contratos: this.object.contratoId,
          inicioContrato: this.object.inicioContrato
            ? moment(this.object.inicioContrato, "DD/MM/YYYY")
            : null,
          fimContrato: this.object.fimContrato
            ? moment(this.object.fimContrato, "DD/MM/YYYY")
            : null,
          monitoramento:
            this.object.monitoramento > 0 ? this.object.monitoramento : 1,
        };

        this.municipioGrupoSolucao = this.object.municipioGrupoSolucao;
      }
      this.dialog = false;
    },
    changeUser(e) {
      this.payload.usuarioId = e;
      this.$forceUpdate();
    },
    // Métodos para gerenciar contratos por usuário
    carregarContratosExistentes() {
      try {
        // Limpa contratos existentes
        this.contratosPorUsuario = {};

        // Se há contratos municipioSolucaoContrato no objeto
        if (
          Array.isArray(this.object?.municipioSolucaoContrato) &&
          this.podeSelecionarMaisDeUmUsuarioSolucao &&
          this.object?.municipioSolucaoContrato.length > 0
        ) {
          this.object.municipioSolucaoContrato.forEach((municipioContrato) => {
            if (municipioContrato.contrato) {
              // Encontra o índice do usuário correspondente
              const usuarioIndex = this.usuariosSelecionados.findIndex(
                (user) => {
                  const userId =
                    typeof user === "object" ? user.usuarioId : user;
                  return userId === municipioContrato.contrato.usuarioId;
                }
              );

              if (usuarioIndex !== -1) {
                // Armazena apenas o primeiro contrato para cada usuário
                this.$set(this.contratosPorUsuario, usuarioIndex, {
                  contratos: municipioContrato.contrato,
                });
              }
            }
          });
        }
        // Se há apenas um contrato no payload (formato antigo)
        else if (this.object?.contratoRelacao?.contratoId) {
          const usuarioIndex = this.usuariosSelecionados.findIndex((user) => {
            const userId = typeof user === "object" ? user.usuarioId : user;
            return userId === this.object?.contratoRelacao?.usuarioId;
          });

          if (usuarioIndex !== -1) {
            this.$set(this.contratosPorUsuario, usuarioIndex, {
              contratos: this.object?.contratoRelacao,
            });
          }
        }

        // Força atualização de todos os componentes filhos
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      } catch (error) {
        console.error("Erro ao carregar contratos existentes:", error);
        this.contratosPorUsuario = {};
      }
    },

    getUsuarioNome(usuario, index) {
      let userName = usuario.nome;
      if (!userName) {
        userName = usuario?.usuario?.nome;
      }

      if (userName) {
        return `Contrato do responsável:  ${userName}`;
      }

      return "";
    },

    getContratosFilter(index) {
      try {
        if (!this.contratosPorUsuario[index]) {
          this.$set(this.contratosPorUsuario, index, { contratos: null });
        }

        // Retorna apenas 1 contrato (o primeiro do array ou null)
        const contratos = this.contratosPorUsuario[index]?.contratos;
        const contrato = Array.isArray(contratos) ? contratos[0] : contratos;

        const filterObject = {
          contratos: contrato || null,
        };

        return filterObject;
      } catch (error) {
        console.error(`Erro em getContratosFilter(${index}):`, error);
        return { contratos: null };
      }
    },

    updateContratos(index, contrato) {
      if (!this.contratosPorUsuario[index]) {
        this.$set(this.contratosPorUsuario, index, {});
      }
      this.$set(this.contratosPorUsuario[index], "contratos", contrato);
      this.updatePayloadContratos();
    },

    updatePayloadContratos() {
      const todosContratos = [];
      Object.values(this.contratosPorUsuario).forEach((userContratos) => {
        if (userContratos.contratos) {
          todosContratos.push(userContratos.contratos);
        }
      });

      this.payload.contratos = todosContratos.length > 0 ? todosContratos : [];
    },

    onConfirm() {
      if (
        !this.municipioGrupoSolucao &&
        !this.payload.municipioGrupoSolucao &&
        !this.payload.municipioGrupoSolucao.municipioGrupoSolucaoId
      ) {
        this.$notification.error(
          `O preenchimento de um ${
            this.isAT
              ? "Grupo de Iniciativa"
              : this.isGov
              ? "Grupo de Fases"
              : "Grupo de Solução"
          } é obrigatório.`
        );
        return;
      }

      this.setLoading(true);
      let usuarioWithou0 = this.payload.usuarioId;

      if (Array.isArray(usuarioWithou0)) {
        usuarioWithou0 = usuarioWithou0
          .map((item) => {
            if (typeof item === "object") {
              return item.usuarioId;
            }

            return item;
          })
          .filter((user) => user > 0);
      }

      let usuarioId = usuarioWithou0[0] || usuarioWithou0;
      let usuariosId = usuarioWithou0;

      if (typeof usuarioId !== "number") {
        usuarioId = usuarioId.usuarioId;
      }

      if (!Array.isArray(usuariosId)) {
        usuariosId = [usuarioId];
      }

      if (usuariosId.length > 0) {
        usuariosId = usuariosId.map((element) => {
          if (typeof element !== "number") {
            return element.usuarioId;
          }

          return element;
        });
      }

      // Extrai todos os contratosId como array de inteiros mapeados por usuário
      const contratosId = [];
      const contratosPorUsuarioArray = [];

      // Itera pelos usuários selecionados para manter a ordem correta
      this.usuariosSelecionados.forEach((usuario, index) => {
        const userId =
          typeof usuario === "object" ? usuario.usuarioId : usuario;

        if (
          this.contratosPorUsuario[index] &&
          this.contratosPorUsuario[index].contratos
        ) {
          const userContrato = this.contratosPorUsuario[index].contratos;

          // Como agora é apenas 1 contrato por usuário
          if (userContrato && userContrato.contratoId) {
            contratosId.push(userContrato.contratoId);
            contratosPorUsuarioArray.push({
              usuarioId: userId,
              contratoId: userContrato.contratoId,
              contrato: userContrato,
            });
          }
        }
      });

      const valores = {
        ...this.payload,
        usuariosId: usuariosId,
        usuarioId: usuarioId,
        contratosId: contratosId,
        contratosPorUsuario: contratosPorUsuarioArray,
        contratoId: contratosId[0],
        municipioGrupoSolucaoId:
          this.payload.municipioGrupoSolucao.municipioGrupoSolucaoId ||
          (this.municipioGrupoSolucao &&
            this.municipioGrupoSolucao.municipioGrupoSolucaoId),
        municipioGrupoSolucao: null,
        inicioContrato: this.payload.inicioContrato
          ? moment(this.payload.inicioContrato, "DD/MM/YYYY")
          : null,
        fimContrato: this.payload.fimContrato
          ? moment(this.payload.fimContrato, "DD/MM/YYYY")
          : null,
      };

      if (this.edit === true) {
        citySolutionAPI
          .update(valores)
          .then(() => {
            this.dialog = false;
            this.setLoading(false);
            this.payload = { ...this.object };

            this.$emit("onSave");
          })
          .catch((resp) => {
            this.setLoading(false);
            console.log("Erro ao editar solução ", resp);

            this.$notification.error(
              `"Erro ao atualizar ${
                this.isAT ? "iniciativa" : this.isGov ? "fases" : "solução"
              }`
            );
          });
      } else {
        citySolutionAPI
          .create(valores)
          .then(() => {
            this.dialog = false;
            this.setLoading(false);
            this.payload = {
              monitoramento: 1,
              municipioId: this.$route.params.id,
              contratos: {},
              municipioGrupoSolucao: this.municipioGrupoSolucao,
            };

            this.$emit("onSave");
          })
          .catch((resp) => {
            this.setLoading(false);
            console.log("Erro ao criar solução ", resp);
            this.$notification.error(
              `Erro ao criar ${
                this.isAT ? "iniciativa" : this.isGov ? "fases" : "solução"
              }`
            );
          });
      }
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        if (this.object && this.edit === true) {
          this.payload = {
            ...this.object,
            inicioContrato: this.object.inicioContrato
              ? moment(this.object.inicioContrato).format("DD/MM/YYYY")
              : null,
            fimContrato: this.object.fimContrato
              ? moment(this.object.fimContrato).format("DD/MM/YYYY")
              : null,
            monitoramento:
              this.object.monitoramento > 0 ? this.object.monitoramento : 1,
          };

          usuarioPermissaoMunicipioSolucaoApi
            .list(this.payload.municipioId, this.payload.municipioSolucaoId)
            .then(({ data: usuarios }) => {
              if (this.podeSelecionarMaisDeUmUsuarioSolucao) {
                if (usuarios.length > 0) {
                  // Mantém os objetos completos dos usuários em vez de apenas IDs
                  let users = usuarios.map((element) => {
                    if (typeof element !== "number") {
                      return element; // Retorna o objeto completo
                    }
                    return element;
                  });

                  this.payload.usuarioId = users || this.payload.usuarioId;
                } else {
                  var newValue = this.payload.usuarioId;
                  this.payload.usuarioId = [];
                  if (newValue) this.payload.usuarioId.push(newValue);
                }
              } else if (
                !this.isFullAdmin &&
                this.config.podeSelecionarMaisDeUmUsuarioSolucao &&
                this.groupsConfig.podeSelecionarMaisDeUmUsuarioSolucao
              ) {
                var newValue = this.payload.usuarioId;
                this.payload.usuarioId = [];
                if (newValue) this.payload.usuarioId.push(newValue);
              }

              // Carrega os contratos existentes mapeados por usuário
              this.$nextTick(() => {
                setTimeout(() => {
                  this.carregarContratosExistentes();
                }, 100);
              });

              this.loadfirst = true;
            });
        }
      }
    },
    "filter.municipioGrupoSolucao": {
      handler(newValue) {
        if (this.filter.municipioGrupoSolucao) {
          this.municipioGrupoSolucao = newValue;
        }
      },
      deep: true,
    },
    object(newValue) {
      this.payload = newValue;
      this.municipioGrupoSolucao = newValue.municipioGrupoSolucao;
    },
    "payload.usuarioId": {
      handler(newUsuarios, oldUsuarios) {
        // Só limpa contratos se realmente removeu usuários
        // Não limpa quando apenas adiciona novos usuários
        if (
          oldUsuarios &&
          Array.isArray(oldUsuarios) &&
          Array.isArray(newUsuarios)
        ) {
          const usuariosRemovidosIds = oldUsuarios.filter((oldUser) => {
            const oldId =
              typeof oldUser === "object" ? oldUser.usuarioId : oldUser;
            return !newUsuarios.some((newUser) => {
              const newId =
                typeof newUser === "object" ? newUser.usuarioId : newUser;
              return newId === oldId;
            });
          });

          // Se removeu usuários, limpa apenas os contratos dos usuários removidos
          if (usuariosRemovidosIds.length > 0) {
            const novosContratos = {};
            newUsuarios.forEach((user, index) => {
              if (this.contratosPorUsuario[index]) {
                novosContratos[index] = this.contratosPorUsuario[index];
              }
            });
            this.contratosPorUsuario = novosContratos;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.municipioGrupoSolucao = this.filter.municipioGrupoSolucao;

    if (this.podeSelecionarMaisDeUmUsuarioSolucao) {
      this.contratos = [];
    }

    if (this.isAT || this.isGov) {
      this.tiposMonitoramento = [
        { label: "Atividades", value: 1 },
        { label: "Visitas", value: 2 },
      ];
    }
  },
};
</script>
<style>
.detalhesContrato {
  border: 1px solid #a6a0a0;
  border-radius: 10px;
  font-size: 14px;
  color: #000;
  background: #f5f5f5;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.valorContrato {
  font-weight: bold;
}

.tituloContrato {
  font-size: 16px;
  text-align: center;
  margin-bottom: 10px;
}
</style>
